import { animated } from "@react-spring/web";
import styled from "styled-components";

export const Wrapper = styled(animated.div)`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 45px;

  @media (max-width: 768px) {
    padding: 36px;
  }
`;

export const Title = styled.h3`
  text-transform: initial;
  margin-bottom: 45px;
  font-size: 28px;
  text-align: center;
`;

export const SubTitle = styled.h3`
  text-transform: initial;
  margin-bottom: 45px;
  font-size: 20px;
  text-align: center;
`;
